import { render, staticRenderFns } from "./DseLabel.vue?vue&type=template&id=211bc92e&scoped=true"
import script from "./DseLabel.vue?vue&type=script&lang=js"
export * from "./DseLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211bc92e",
  null
  
)

export default component.exports